const SamlResponse = function(form, sp, samlResponse, samlRequest, relayState) {
  this.form = form
  this.sp = sp
  this.samlResponse = samlResponse
  this.samlRequest = samlRequest
  this.relayState = relayState
}

export default SamlResponse


/** WEBPACK FOOTER **
 ** ./components/identity-provider/saml-response.js
 **/